const PropertyTypes = [
	'Bien détenu en pleine propriété par vous-même',
	'Bien détenu en pleine propriété par votre conjoint ou partenaire de PACS',
	'Bien détenu en nue-propriété par vous-même',
	'Bien détenu en nue-propriété par votre conjoint ou partenaire de PACS',
	'Bien détenu en usufruit par vous-même',
	'Bien détenu en usufruit par votre conjoint ou partenaire de PACS',
	'Bien détenu en indivision',
	'Autre'
]

export default PropertyTypes



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/PropertyTypes.js